<template>
  <v-dialog width="500px" :value="value" @input="toggleModal()" persistent scrollable>
    <v-card class="kbLight">
      <v-toolbar class="kbPink" dark text flat>
        <div class="text-h6">{{ $t('general.newPerson') }}</div>
        <v-spacer></v-spacer>
        <v-btn icon @click="toggleModal()">
          <v-icon>clear</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-form v-model="validUser" ref="newUserForm" lazy-validation>
          <v-row>
            <v-col class="pb-0 pt-6" cols="12">
              <v-text-field :label="$t('general.firstName')"
                            color="kbDarkBlueText"
                            :rules="[!formUser.email && !countryPhonePicker.phone ? rules.required : true]"
                            v-model="formUser.name">
              </v-text-field>
            </v-col>

            <v-col class="pb-0" cols="12">
              <v-text-field :label="$t('general.lastName')"
                            color="kbDarkBlueText"
                            v-model="formUser.lastName">
              </v-text-field>
            </v-col>

            <v-col class="pb-0" cols="12">
              <country-phone-picker :value="countryPhonePicker"
                                    :rules="[!formUser.email && !formUser.name ? rules.required : true]"
                                    @input="setCountryPhone"/>
            </v-col>

            <v-col cols="12" class="pb-0">
              <v-text-field label="Email"
                            color="kbDarkBlueText"
                            :rules="[!countryPhonePicker.phone && !formUser.name ? rules.required : true, rules.email]"
                            v-model="formUser.email">
              </v-text-field>
            </v-col>

            <v-col class="pb-0" cols="12">
              <v-select :label="$t('general.rol')"
                        color="kbDarkBlueText"
                        item-color="kbDarkBlueText"
                        v-model="formUser.rolId"
                        item-text="name"
                        item-value="id"
                        :items="roles"
                        multiple
                        :no-data-text="$t('general.rolesNotCreated')">
                <template slot="selection"
                          slot-scope="{ item, index }">
                  <v-chip color="kbPink" dark close @click:close="deleteRol(index)">
                    <span>{{ item.name }}</span>
                  </v-chip>
                </template>
              </v-select>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="mr-2"
               color="red"
               outlined
               @click="toggleModal()">
          {{ $t('general.cancel') }}
        </v-btn>
        <v-btn color="kbPink"
               dark
               @click="submit"
               :loading="creatingUser">
          {{ $t('general.addNewPerson') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex'
import notifications from '@/libs/notifications'
import rules from '@/libs/rules'
import CountryPhonePicker from '@/components/ui/CountryPhonePicker'
export default {
  components: { CountryPhonePicker },
  computed: {
    ...mapState({
      loadingRoles: state => state.roles.loadingRoles,
      roles: state => state.roles.roles,
      selectedApp: state => state.apps.selectedApp
    })
  },
  data () {
    return {
      creatingUser: false,
      formUser: {
        email: '',
        lastName: '',
        name: '',
        rolId: '',
        phone: '',
        country: '',
        countryCode: ''
      },
      validUser: true,
      rules: rules,
      countryPhonePicker: {
        country: 'Colombia',
        code: 'co',
        number: '57',
        phone: ''
      }
    }
  },
  methods: {
    async submit () {
      try {
        if (!this.$refs.newUserForm.validate()) return

        this.creatingUser = true
        const user = await this.$store.dispatch('createUser', this.formUser)
        await this.$emit('getUsers')
        if (this.listId) {
          await this.$store.dispatch('addUserToList', { userId: user.UUID, listId: this.listId })
          await this.$store.dispatch('getUsersOfSpecificList', { listId: this.listId })
        }

        notifications.success(this.$t('general.personSuccessfullyAdded'))
        this.creatingUser = false
        this.toggleModal()
      } catch (e) {
        this.creatingUser = false
        console.error(e)
      }
    },
    resetForm () {
      this.countryPhonePicker = {
        country: 'Colombia',
        code: 'co',
        number: '57',
        phone: ''
      }
      this.formUser = {
        email: '',
        lastName: '',
        name: '',
        rolId: '',
        phone: '',
        country: '',
        countryCode: ''
      }
      this.$refs.newUserForm.reset()
    },
    deleteRol (index) {
      this.formUser.rolId.splice(index, 1)
    },
    setCountryPhone (data) {
      this.countryPhonePicker = data

      this.formUser.phone = data.phone
      this.formUser.country = data.code
      this.formUser.countryCode = data.number
    },
    toggleModal () {
      this.$emit('input', false)
      this.resetForm()
    }
  },
  props: ['listId', 'value'],
  watch: {
    selectedApp () {
      this.$store.dispatch('getRoles')
    }
  }
}
</script>
